export default "__VITE_ASSET__Bxx6cgKa__"